import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { QuickSummaryButtonPlaceholder } from '../src/QuickSummaryButtonPlaceholder.tsx';

export const QuickSummaryPopup = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-QuickSummaryPopup" */ '../src/QuickSummaryPopup.tsx'
			)
		).QuickSummaryPopup,
	loading: ({ buttonStyles }) => <QuickSummaryButtonPlaceholder buttonStyles={buttonStyles} />,
});
